import moment from 'moment-timezone';
import get from 'lodash/get';
import { isErrorCodeByDimension } from '@utils/dimension/errorCodeHelper';


export const createCompareDashboard = () => ({});

const defaultBirdChart = {
  brushEnd: 0,
  brushStart: 0,
  sliceFrom: 0,
  sliceTo: 0,
  zoomEnd: 0,
  zoomStart: 0,
};

// side effect. need refactor
const getViewerDrillDownStore = (interval) => {
  let { from, to } = interval;
  let features = null;
  let birdChart = null;
  if (window.store && window.store.getState) {
    const reduxStore = window.store.getState();
    features = get(reduxStore, 'common.features', null);
    birdChart = get(reduxStore, '["module:trends"].birdChart.chart', null);
  }

  if (features === null || birdChart === null) {
    return null;
  }

  const [birdChartFrom, birdChartTo] = birdChart.interval;
  const [zoomStart, zoomEnd] = birdChart.zoom;
  const [brushStart, brushEnd] = birdChart.brush;

  if (birdChart.chartType === 'bar' && birdChartFrom && birdChartTo) {
    from = birdChartFrom;
    to = birdChartTo;
  }

  return {
    zoomStart,
    zoomEnd,
    brushStart: birdChart.chartType === 'bar' ? 0 : brushStart,
    brushEnd: birdChart.chartType === 'bar' ? 0 : brushEnd,
    sliceFrom: moment(from).toISOString(),
    sliceTo: moment(to).toISOString(),
  };
};

/**
 * @param {object} interval
 * @param {string} code
 * @param {string} metric
 * @param {object} filter
 * @description src/store/errorDiagnostics/sharing/selectors.js
 * @description Pls take a look before you use the function
 */
export const createErrorDiagnosticsDashboard = ({
  interval,
  code,
  metric,
  filter,
  birdChart = {},
  dimensionNames = [],
  viewerDrillDownInterval,
}) => {
  const viewerDrillDownStore = getViewerDrillDownStore(viewerDrillDownInterval);
  let formatBirdChart = { ...defaultBirdChart, ...birdChart };

  let sliceFrom = '';
  let sliceTo = '';

  if (viewerDrillDownStore !== null) {
    formatBirdChart = {
      ...viewerDrillDownStore,
    };
  } else {
    const { sliceFrom: defaultSliceFrom, sliceTo: defaultSliceTo } = defaultBirdChart;
    if (birdChart.sliceFrom) {
      sliceFrom = moment(birdChart.sliceFrom).toISOString();
    } else {
      sliceFrom = defaultSliceFrom;
    }

    if (birdChart.sliceTo) {
      sliceTo = moment(birdChart.sliceTo).toISOString();
    } else {
      sliceTo = defaultSliceTo;
    }
    formatBirdChart = {
      ...formatBirdChart,
      sliceFrom,
      sliceTo,
    };
  }

  return {
    base: {
      interval: {
        ...interval,
        from: moment(interval.from).toISOString(),
        to: moment(interval.to).toISOString(),
      },
      currentErrorCode: code,
      errorCodeSelected: [code],
      metric,
      code,
      filter,
    },
    birdChart: formatBirdChart,
    dimensionTables: {
      dimensions: dimensionNames.filter(
        name => !isErrorCodeByDimension(name),
      ),
      unit: 'Count',
    },
  };
};
